import React, { useCallback, useEffect, useState } from 'react'
import { convertToCDNLink, FLAT_GRADIENTS, Icons, formatDate, latexDelimiters } from '../../utils/utilities'
import AnnouncementDialog from '../../components/common/AnnouncementDialog'
import { Box, Typography, useTheme } from '@mui/material'
import Latex from 'react-latex-next'
import api from '../../service/api'

const AnnouncementsCard = () => {

    const [announcements, setAnnouncements] = useState( [] )
    const [selectedAnnouncement, setSelectedAnnouncement] = useState( null )

    const { shadows, palette, theme } = useTheme()

    const fetchAnnouncements = useCallback( async () => {
        try {
            const { data: { data } } = await api.announcements.fetchAnnouncements( { purpose: "announcement" } )
            setAnnouncements( data )
        } catch ( err ) {
            console.log( err )
        }
    }, [] )

    useEffect( () => {
        fetchAnnouncements()
    }, [fetchAnnouncements] )

    if ( announcements.length === 0 )
        return null
    if ( announcements.length === 0 )
        return null

    return (
        <Box>

            {Boolean( selectedAnnouncement ) && <AnnouncementDialog state={Boolean( selectedAnnouncement )} onClose={() => setSelectedAnnouncement( null )} announcement_id={selectedAnnouncement} />}

            <Box display="flex" flexDirection="column" gap="10px">

                {announcements.map( ( announcement, announcementIndex ) => {
                    const lastUpdated = new Date( announcement.announcement_updated_at ).toLocaleDateString()
                    const today = new Date().toLocaleDateString()
                    let yesterday = new Date()
                    yesterday.setDate( new Date().getDate() - 1 )
                    yesterday = yesterday.toLocaleDateString()
                    let lastUpdatedString
                    if ( lastUpdated === today )
                        lastUpdatedString = "Today"
                    else if ( lastUpdated === yesterday )
                        lastUpdatedString = "Yesterday"
                    else {

                        let llformatDate = formatDate( lastUpdated, { format: "ll" } )
                        const [dateAndMonth, year] = llformatDate?.split( ", " )

                        if ( +year === new Date().getFullYear() )
                            lastUpdatedString = dateAndMonth
                        else
                            lastUpdatedString = `${dateAndMonth}\n${year}`
                    }

                    const { background: bg, color } = FLAT_GRADIENTS[( announcementIndex % FLAT_GRADIENTS.length )]

                    return (
                        <Box onClick={() => setSelectedAnnouncement( announcement.id )} overflow="clip" position="relative" className="animation-wave-thrice" border={`2px solid ${palette.error.main}`} bgcolor={palette.error.light + 22} sx={{ zIndex: 10, cursor: "pointer", transition: "200ms", ":hover": { boxShadow: shadows[1], transform: `scale(1.005)` } }} borderRadius="5px" padding="10px" key={announcement.id}>
                            <Box top="-150px" right="-150px" sx={{ opacity: !announcement.cover_image ? 0.7 : 0.4, zIndex: 0, position: "absolute", width: "500px", height: "500px", borderRadius: "50%", overflow: "hidden" }} >
                                {announcement.cover_image && <img src={convertToCDNLink( announcement.cover_image )} alt={`${announcement.id}-cover`} />}
                            </Box>
                            <Box display="flex" alignItems="flex-start" gap="10px" sx={{ zIndex: "10", position: "relative" }}>
                                <Typography display="flex" gap="5px" variant="subtitle2" fontWeight="400" flexDirection="column" fontSize="20px" color={theme === 'dark' ? palette.text.error : palette.error.main} alignItems="center" > {Icons.default.AnnouncementMic} </Typography>

                                <Box>
                                    <Typography marginBottom="5px" variant="h1" color={theme === 'dark' ? palette.text.error : palette.error.main} fontWeight="700" component="h1" fontSize="16px">{announcement.announcement_title}</Typography>
                                    <Box fontSize="12px" color={theme === 'dark' ? palette.text.primary : palette.error.main} overflow="auto" className="slim-custom-scrollbar truncate-2-lines" height={{ md: "100%", xs: "initial" }}>
                                        <Latex delimiters={latexDelimiters}>{announcement.announcement_message}</Latex>
                                    </Box>
                                    {/* <Button onClick={() => setSelectedAnnouncement( announcement.id )} variant='outlined' size="small" sx={{ marginTop: "5px", border: `1px solid ${color}`, color: color, bgcolor: "none", textTransform: "capitalize", "&:hover": { border: `1px solid ${color}`, color: color, bgcolor: "none" } }} endIcon={Icons.default.ArrowOutward}>View Announcement</Button> */}
                                </Box>
                            </Box>
                        </Box>
                    )
                } )}
            </Box>
        </Box >
    )
}

export default AnnouncementsCard
